// extracted by mini-css-extract-plugin
export default {"Container":"GalleryItem_Container__eEarp","TimesIcon":"GalleryItem_TimesIcon__at5n6","Media":"GalleryItem_Media__fQVSe"};